import React, { useState, useEffect} from "react";
import { Container, Box } from "@material-ui/core";
import {
  Typography,
  TextField,
  Button,
  IconButton
} from "@material-ui/core";
import {
  CircularProgress,
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  DialogContentText,
  LinearProgress,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  FormControl,
} from "@material-ui/core";
import {
  Add,
  Close,
  Delete,
  Gavel
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";

import MUIDataTable from "mui-datatables";

import { makeStyles } from "@material-ui/styles";
import {Wizanlytics} from "./../../../../../utils/web_config_2";
import { useSnackbar } from "notistack";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      marginLeft: 250,
    },
  },
  title: {
    flexGrow: 1,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  action: {
    borderRadius: 15,
  },
}));


  
  function CreateBusinessRules(props) {
    const classes = useStyles();
    const history = useHistory();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
 

    const [token,setToken]=useState("eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5M2FmZTc3OC1mZWExLTRjMDktYTNlMy1kNmM3MzkyNjRmODciLCJqdGkiOiI0NzBiYWEwZjczOWQyNGVlZThhMTIzMDhkNDJjYWI5YjNkMjUwMDU4NDRhZWU5YzNjZjYxYmNmMzE4MTgzZmYxZmIxMjdhMDRkMjIyZDQxNCIsImlhdCI6MTYyNDgyMDUyNS43Mzg3NDgsIm5iZiI6MTYyNDgyMDUyNS43Mzg3NiwiZXhwIjoxNjU2MzU2NTI1LjczMDE0Mywic3ViIjoiIiwic2NvcGVzIjpbXX0.4GSyTd6LzKB-JFP8oQ_DsITZXAmnVBfqMlwvoiJkiXLI9p3hD1HlpC36bcGA0qnxkOblnC2sqLjEcdNrybY6dqRrHTOGRr_6plFuhaL1pUm4E8xj-A0uwCpoPPdxaiZBwAT-SNPX3VzCYRo147VYaX2g9O8FcCp9lnqd4f71V6RnYA_h1PEOGk16UxT1Bvx25MDKZl6G722PR0R65v4dV8wDPHiW8vtFYsIGvE25LPyhG6UUikGlsYd9Eg8zE4AbSQ9BNYKkXiFQ6zNbZJM31I3PAX6kK9nlY13SehnL8CAlbCPRZtq8fu3O9uUaxfP0pOgmROjDDu7sxpWKbrWjOv97ISXFle-gUcmc17c-49zW9pmrWeAnpO14xNQ34OWRxID-opx-XNNU5lEinqTN-y9fP06mUvY0X-YkIR8p2kYJubwl2jaS2ttTVI67mxr4tafqh5gZhiWY6aB2_8oAOMZQG5bNwTqexurqUqiFZLCbnootgqLQKavHmdyt8nSP4F-VkNNUSo3Fu18GqwG3oDhFVYcUPW6Ke6_EgsJcFRQC1B-UvC4LkY6imxqvlfTWP4Hy4tjRRaPBwYqzO78aXokZ_Wm7mmFsFGV3J7dWdUVXLkOAyc7iznBvHVMd3iRVAeMfPAbMPpWug6wB-_mE1CwXgmxxDqc5q0bNxeHYAfs");

  useEffect(() => {

    // const wzauth={};
    // const wzauth1 = localStorage.getItem("wz_auth");
    // if (wzauth1 != null) {
    //     wzauth = JSON.parse(wzauth1);
    // }else{
    //     authenticate(); 
    // }


    getBusinessRules(token);

  }, []);



  const authenticate=()=>{

    var authData={
        grant_type:"client_credentials",
        client_id:process.env.REACT_APP_WIZ_CLIENT_ID,
        client_secret:process.env.REACT_APP_WIZ_CLIENT_SECRET,
        scope:""
    };

    const authInstance = axios.create(new Wizanlytics().setHeadersAuth());
    authInstance.post(new Wizanlytics().AUTHENTICATE,authData)
    .then((res)=>{
        var data=res.data;
        localStorage.removeItem("wz_auth");
        localStorage.setItem("wz_auth",data);
        getBusinessRules(data.access_token);
    })
    .catch((err)=>{


    });

  }


  const [rules, setRules] = useState({
    page: 0,
    count: 1,
    rowsPerPage: 10,
    sortOrder: {},
    saving: false,
    loading: false,
    dialog:false,
    data: [],
  });


  const [status,setStatus]=useState("Loading business rules...")

  const getBusinessRules=(token)=>{

    setRules({ ...rules, loading: true });
    const rulesInstance = axios.create(new Wizanlytics().setHeaders(token));
    rulesInstance
      .get(new Wizanlytics().GET_BUSINESS_RULES)
      .then((res)=>{

        setRules({ ...rules, loading: false });
        var data=res.data.data;


        if(data.length==0){
            console.log("=== no rules ===");
            setStatus("No business rules available")

        }else{
            var r = [];

            data.forEach((rr, i) => {
              const newRule = rr;
              newRule['is_global']=rr.attributes.is_global===1?"Yes":"No";
              newRule['travel_distance']=rr.attributes.travel_distance+" Km";
              newRule['reward_value']=rr.attributes.reward_value;
  
              r.push(rr);
            });

            setRules({
              ...rules,
              data: r,
            });
            
        }


      })
      .catch((error)=>{

        setRules({ ...rules, loading: false });
          
      })
    
  }





//   rules column 


    const columns = [
        {
            name: "id",
            label: "id",
            options: {
              filter: false,
              sort: false,
              display:"excluded"
            },
          },
    
        {
          name: "travel_distance",
          label: "Travel Distance",
          options: {
            filter: false,
            sort: true,
          },
        },
        {
          name: "reward_value",
          label: "Reward Value",
          options: {
            filter: false,
            sort: false,
          },
        },  {
          name: "is_global",
          label: "Global",
          options: {
            filter: false,
            sort: false,
          },
        }
      ];

      const options = {
        filterType: "multiselect",
        elevation: 0,
        selectableRows: "single",
        searchPlaceholder: "Search rule...",
        selectableRowsOnClick: true,
        fixedHeader: true,
        onCellClick: (cellData, cellMeta) => {

        //   var user = users.data[cellMeta.dataIndex];
    
        //   if(user==null){
        //     return
        //   }
        //   getOperators(accountData.token,user.user_id)
        //   setSelectedAgent({...selectedAgent,data:user,open:true})

        },
        searchProps: {
          variant: "outlined",
          margin: "dense",
        },
        textLabels: {
          body: {
            noMatch: status,
          },
        },
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
          <CustomRulesToolbar
            selectedRows={selectedRows}
            displayData={displayData}
            openDelete={preDelete}
          />
        ),
      };

    //   create new business rule



    const [distance,setDistance]=useState({value:null,error:""});
    const [reward,setReward]=useState({value:null,error:""});
    const [isGlobal,setIsGlobal]=useState({value:false,error:""});

    const saveBusinessRule=()=>{
        if(distance.value===0 && distance.value!=null){
            setDistance({value:0,error:"Invalid distance"});
        }else if(reward.value==0 && reward.value!=null){
            setReward({value:0,error:"Invalid reward"});
        }else{
            setRules({...rules,saving:true});
            const businessData={
                travel_distance:distance.value,
                reward_value:reward.value,
                is_global:isGlobal.value==true?1:0
            };

            const ruleInstance = axios.create(new Wizanlytics().setHeaders(token));
            ruleInstance.post(new Wizanlytics().NEW_BUSINESS_RULE,businessData)
            .then((res)=>{

                setRules({...rules,saving:false});
                var exist=rules.data;

                var data=res.data.data;
                /// add added data
                data['is_global']=data.attributes.is_global===1?"Yes":"No";
                data['travel_distance']=data.attributes.travel_distance+" Km";
                data['reward_value']=data.attributes.reward_value;
                exist.push(data);

                setRules({...rules,data:exist,dialog:false});

                notify("success","Business rule added");
                


            })
            .catch((err)=>{
                setRules({...rules,saving:false});
                notify("error",err?.response?.data?.errors?.travel_distance[0]!=undefined?err?.response?.data?.errors?.travel_distance[0]:""+" "+err?.response?.data?.errors?.reward_value[0]!=undefined?err?.response?.data?.errors?.reward_value[0]:""+" "+err?.response?.data?.errors?.is_global[0]!=undefined?err?.response?.data?.errors?.reward_value[0]:"");
            });

        }
    }

    // delete business rule
    const [warning,setWarning]=useState(false);
    const [ruleId,setRuleId]=useState(null);
    const [deleteLoad,setDeleteLoad]=useState(false);


    const deleteRule=()=>{
      setDeleteLoad(true);
      const deleteInstance = axios.create(new Wizanlytics().setHeaders(token));
      deleteInstance.delete(new Wizanlytics().DELETE_BUSINESS_RULE+ruleId)
      .then((res)=>{
        setWarning(false);
        setDeleteLoad(false);
        var existRules=rules.data.filter((r)=>r.id!=ruleId);
        setRules({...rules,data:existRules});
        notify("success","Rule deleted successful!");
      })
      .catch((err)=>{
        setDeleteLoad(false);
        notify("error","Something went wrong");
      });
    }



    function preDelete(id){
      setRuleId(id);
      setWarning(true);
    }





    const notify = (variant, msg, status) => {
        if (status == 401) {
          history.push("/", { expired: true });
        }
        enqueueSnackbar(msg, {
          variant: variant,
          action: (k) => (
            <IconButton
              onClick={() => {
                closeSnackbar(k);
              }}
              size="small"
            >
              <Close fontSize="small" />
            </IconButton>
          ),
        });
      };

    return(
<div className={classes.root}>

{/* delete business rule  */}

<Dialog
        open={warning}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Warning"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
           <Typography>Are you sure? you want to delete this business rule</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
          size="small"
            onClick={() => {
              setWarning(false);
            }}
            color="secondary"
          >
            Cancel
          </Button>
          <Button
          size="small"
            onClick={() => {
                //delete business rule 
                deleteRule();
            }}
            color="primary"
            autoFocus
          >
            {deleteLoad==true?(<CircularProgress size={23} />):("Delete")}
          </Button>
        </DialogActions>
      </Dialog>


{/* new business rule  */}



<Dialog
        open={rules.dialog}
        maxWidth="sm"
        fullWidth
        onClose={() => {

            setRules({...rules,dialog:false});
        }}
      >
        <DialogTitle id="new-business-rule">
          New Business rule
        </DialogTitle>
        <DialogContent>
          
          <Box mt={2}>
                <TextField
                  required
                  size="small"
                  variant="outlined"
                  color="primary"
                  value={distance.value}
                  placeholder={"Distance"}
                  label={"Distance"}
                  fullWidth
                  onChange={(e)=>{
                      var v=e.target.value;
                      if(v>0){
                          setDistance({value:v,error:""});
                      }else{
                          setDistance({value:null,error:"Invalid distance"});
                      }
                  }}
                  helperText={distance.error}
                  error={distance.error !== ""}
                />
              
          </Box>

          <Box mt={2}>
                <TextField
                  required
                  size="small"
                  variant="outlined"
                  color="primary"
                  value={reward.value}
                  placeholder={"Reward Value"}
                  label={"Reward Value"}
                  fullWidth
                  onChange={(e)=>{
                      var v=e.target.value;
                      if(v>0){
                          setReward({value:v,error:""});
                      }else{
                          setReward({value:null,error:"Invalid reward"});
                      }
                  }}
                  helperText={reward.error}
                  error={reward.error !== ""}
                />
          </Box>

          <Box mt={2}>
            <FormControl
              className={classes.formControl}
              fullWidth
              variant="outlined"
              size="small"
              error={isGlobal.error !== ""}
            >
              <InputLabel id="type">
                Is it global
              </InputLabel>
              <Select
                label={"Is global"}
                value={isGlobal.value}
                onChange={(e)=>{
                    var v=e.target.value;
                    setIsGlobal({value:v,error:""});
                }}
              >
                <MenuItem value={true}>Yes</MenuItem>
                <MenuItem value={false}>No</MenuItem>
              </Select>
              <FormHelperText>{isGlobal.error}</FormHelperText>
            </FormControl>
          </Box>





        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => {
            setRules({...rules,dialog:false});
            }}
            variant="outlined"
            color="primary"
          >
            Cancel
          </Button>
          <Button
            disabled={rules.saving}
            variant="contained"
            color="primary"
            onClick={()=>{
                saveBusinessRule();

            }}
            disableElevation
          >
            {rules.saving ? (
              <CircularProgress size={23} />
            ) : (
              "Save"
            )}

          </Button>
        </DialogActions>
      </Dialog>


<Box display="flex">
        <Box mr={2}>
          {" "}
          <Gavel color="primary" fontSize="large" />
        </Box>
        <Typography variant="h5" className={classes.title}>
          <b>Business Rules</b>
        </Typography>
        <Button
          className={classes.btn}
          color="primary"
          variant="contained"
          size="medium"
          startIcon={<Add />}
          disableElevation
          onClick={() => {
            setRules({...rules,dialog:true});
          }}
        >
          New Business Rule
        </Button>
      </Box>


      <Box mt={3} />

        {rules.loading && <LinearProgress />}
        <MUIDataTable
        title={"List of Business rules"}
        data={rules.data}
        columns={columns}
        options={options}
        />
      

        </div>

    );

    


  }

  function CustomRulesToolbar(props) {
    const { displayData, selectedRows,openDelete} = props;
  
  
    return (
      <Box display="flex" alignItems="center">
        <Box mr={2} ml={2}>
          <Button
            color="primary"
            variant="outlined"
            size="small"
            startIcon={<Delete />}
          onClick={() =>{
            openDelete(displayData[selectedRows?.data[0]?.index]?.data[0]);
          }} 
          >
              Delete
          </Button>
        </Box>
      </Box>
    );
  }

  export default withLocalize(CreateBusinessRules);